export default function (template, templateVars) {
    /* eslint-disable-next-line no-new-func */
    return new Function(`return \`${template.replace(/\${/g, '${this.')}\`;`).call(templateVars);
}
